/**
 * UniverseToggle — Compact pill switcher for the cockpit Header (in nav area).
 * NON-CORE FILE — additive customization.
 */
import React from "react";
import { Sprout, TreePine } from "lucide-react";
import { useUniverse } from "@/lib/jardins-ole/useUniverse";

const UNIVERSES = [
  { id: "jardinerie", Icon: Sprout, label: "Jardinerie" },
  { id: "paysagiste", Icon: TreePine, label: "Paysagiste" },
];

export default function UniverseToggle() {
  const { universe, setUniverse, enabled, configs } = useUniverse();
  if (!enabled) return null;

  return (
    <div
      className="jdo-header-toggle relative inline-flex items-center rounded-full p-0.5 border shadow-md"
      style={{ background: "#FAF7EE", borderColor: "rgba(31, 58, 44, 0.12)" }}
      role="tablist"
      aria-label="Basculer entre Jardinerie et Paysagiste"
      data-testid="jdo-header-toggle"
    >
      {UNIVERSES.map((u) => {
        const isActive = universe === u.id;
        const cfg = configs[u.id];
        const activeColor = u.id === "jardinerie" ? "#1F3A2C" : "#1E3A5F";
        const Icon = u.Icon;
        return (
          <button
            key={u.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => setUniverse(u.id)}
            className="relative z-10 px-3 sm:px-4 py-1.5 rounded-full text-[11px] sm:text-xs font-bold transition-all duration-300 inline-flex items-center gap-1.5"
            style={{
              color: isActive ? "#fff" : "#5C6B5E",
              background: isActive ? activeColor : "transparent",
              boxShadow: isActive ? "0 4px 14px -4px rgba(0,0,0,0.3)" : "none",
            }}
            data-testid={`universe-btn-${u.id}`}
            title={cfg?.tagline || u.label}
          >
            <Icon className="w-3.5 h-3.5" strokeWidth={2.4} />
            <span className="uppercase tracking-wider">{u.label}</span>
          </button>
        );
      })}
    </div>
  );
}
